export const getSafeRandomNumber = () => {
	const array = new Uint32Array(1);
	const [randomNumber] = crypto.getRandomValues(array);
	return randomNumber;
};
